import { create } from 'zustand';

export const useProviderSearchStore = create<{
  searchTerm: string | null;
  setSearchTerm: (term: string | null) => void;
}>((set) => ({
  searchTerm: null,
  setSearchTerm: (searchTerm) => set({ searchTerm }),
}));
